// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"9d82f0da","455":"f3098855","977":"daa88046"}[chunkId] + ".chunk.js";
};